var map = {
	"./1.png": 892450,
	"./10.png": 223150,
	"./2.png": 601897,
	"./3.png": 288788,
	"./4.png": 631247,
	"./5.png": 805214,
	"./6.png": 755620,
	"./7.png": 439175,
	"./8.png": 644191,
	"./9.png": 230262,
	"./back.png": 587470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 334719;